import { Platform } from 'react-native';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastOptions {
  message: string;
  type?: ToastType;
  duration?: number;
  action?: {
    label: string;
    onPress: () => void;
  };
}

class ToastService {
  private static instance: ToastService;
  private toastRef: any = null;

  private constructor() {}

  static getInstance(): ToastService {
    if (!ToastService.instance) {
      ToastService.instance = new ToastService();
    }
    return ToastService.instance;
  }

  setToastRef(ref: any) {
    this.toastRef = ref;
  }

  show(options: ToastOptions) {
    if (!this.toastRef) {
      console.warn('Toast ref not set. Make sure ToastProvider is mounted.');
      return;
    }

    this.toastRef.show(options);
  }

  success(message: string, duration?: number) {
    this.show({ message, type: 'success', duration });
  }

  error(message: string, duration?: number) {
    this.show({ message, type: 'error', duration });
  }

  info(message: string, duration?: number) {
    this.show({ message, type: 'info', duration });
  }

  warning(message: string, duration?: number) {
    this.show({ message, type: 'warning', duration });
  }
}

export const toast = ToastService.getInstance();